<template>
  <div style="border: none">
    <v-select
      v-model="selectedRole"
      :items="rolesOptions"
      item-text="name"
      item-value="value"
      @input="val => updateUserRole(val)"
      hide-details="auto"
      outlined
      dense
    ></v-select>
  </div>
</template>

<script>
  import Vue from 'vue'
  import PermissionsAPI from '@/api/PermissionsAPI'
  import { SET_USERS } from '@/appLogic/permissions/store/constants'
  import Toast from '@/components/common/toasts'
  import { ROLES } from '@/appLogic/permissions/Constants'

  export default Vue.extend({
    components: {},
    data() {
      return {
        params: null,
        selectedRoles: [],
        rolesOptions: null,
      }
    },
    computed: {
      roles() {
        return this.$store.state.permissions.roles
      },
      selectedRole: {
        get() {
          return this.initialRole()
        },
        set(newVal) {
          // No action needed
        },
      },
    },
    mounted() {
      this.setRolesOptions()
    },
    methods: {
      initialRole() {
        let v = this.params.data.roles
        if (v && v.length > 0) {
          const role = ROLES.find(r => r.value === v[0])
          return role
        } else {
          ;('')
        }
      },
      updateUserRole(role) {
        const updatedUser = { ...this.params.data, roles: [role] }
        if (
          this.initialRole.length !== role.length ||
          this.initialRole.every((element, index) => element === role[index])
        ) {
          this.updateUser(updatedUser)
        }
      },
      setRolesOptions() {
        this.rolesOptions = [...ROLES]
      },
      updateUser(updatedUser) {
        PermissionsAPI.upsertUser(updatedUser)
          .then(resp => {
            if (resp) {
              Toast.success({
                title: `User Role Updated`,
                message: `Role for ${resp.first_name} ${resp.last_name} has been updated`,
              })
              PermissionsAPI.getUsers().then(res => {
                this.$store.dispatch(SET_USERS, res)
              })
            }
          })
          .catch(err => {
            console.log('Update user has failed', err)
            Toast.error({
              title: 'Update User Error',
              message: 'Update User has an error, please refresh and try again',
            })
          })
      },
    },
  })
</script>

<style>
  .ag-popup-editor.ag-ltr {
    min-width: 500px !important;
  }
</style>



// WEBPACK FOOTER //
// AgGridRoleSelect.vue?e4c438d8